import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-2xl font-heading font-black text-primary-500 tracking-wide group-hover:text-primary-400 transition-colors">
              八戒影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-400'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-400'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md">
          <div className="px-4 py-4 flex flex-col gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-3 py-2 text-sm font-medium transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500'
                    : 'text-foreground-700'
                }`}
              >
                <i className={`${cat.icon} text-base`} />
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`flex items-center gap-3 py-2 text-sm font-medium transition-colors ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              <i className="ri-information-line text-base" />
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}